'use client';

import { buttonVariants } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { statusDisplay } from '@/constants/post';
import { useSearchParamsContext } from '@/contexts/search-params-context';
import { type PostStatus } from '@/types/post';

import { CollapsibleFilter } from './collapsible-filter';

type StatusFilterProps = {
  defaultOpen?: boolean;
  className?: string;
};

const statusOptions = [
  { value: 'any', label: 'Any status' },
  ...Object.entries(statusDisplay).map(([value, label]) => ({
    value: value as PostStatus,
    label,
  })),
] as const;

export const StatusFilter = ({ defaultOpen, className }: StatusFilterProps) => {
  const { filters, updateFilter } = useSearchParamsContext();

  const handleStatusChange = (status: string) => {
    updateFilter(
      'status',
      status === 'any' ? undefined : (status as PostStatus),
    );
  };

  return (
    <CollapsibleFilter
      title='Status'
      defaultOpen={defaultOpen}
      className={className}
    >
      <Select
        value={filters.status || 'any'}
        onValueChange={handleStatusChange}
      >
        <SelectTrigger
          className={buttonVariants({
            variant: 'outline-brand',
            className: 'justify-between font-normal',
          })}
        >
          <SelectValue placeholder='Select status' />
        </SelectTrigger>
        <SelectContent>
          {statusOptions.map(({ value, label }) => (
            <SelectItem key={value} value={value}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </CollapsibleFilter>
  );
};
